import React from 'react'
import { ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from '@mui/material'

import { Icon } from '~components/internal'
import type { PersonalizationVariable } from '~components/internal/VariableComponents'
import { typography } from '~tokens/internal'

import './VariableInsertMenu.scss'

interface VariableInsertMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  variables: PersonalizationVariable[]
  onVariableInsert: (varKey: string) => void
  className?: string
}

const VariableInsertMenu: React.FC<VariableInsertMenuProps> = ({
  anchorEl,
  open,
  onClose,
  variables,
  onVariableInsert,
  className,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      className={className}
    >
      {variables.flatMap((v, index) => {
        const previous = index > 0 ? variables[index - 1] : undefined
        const showFormHeader = v.group != null && v.group !== previous?.group
        const showSectionHeader =
          v.section != null && (v.group !== previous?.group || v.section !== previous?.section)
        const secondary = /^\w+$/.test(v.key) ? `{{${v.key}}}` : undefined
        const itemClassName =
          v.section != null
            ? 'variable-insert-menu__item--section'
            : v.group != null
              ? 'variable-insert-menu__item--group'
              : undefined

        return [
          showFormHeader ? (
            <ListSubheader key={`form-header-${index}`} disableSticky>
              {v.group}
            </ListSubheader>
          ) : null,
          showSectionHeader ? (
            <ListSubheader
              key={`section-header-${index}`}
              disableSticky
              className='variable-insert-menu__section-header'
            >
              {v.section}
            </ListSubheader>
          ) : null,
          <MenuItem key={v.key} onClick={() => onVariableInsert(v.key)} className={itemClassName}>
            {v.icon && (
              <ListItemIcon>
                <Icon name={v.icon} size={typography.fontSizePx.md} />
              </ListItemIcon>
            )}
            <ListItemText
              primary={v.label}
              secondary={secondary}
              slotProps={{ secondary: { variant: 'caption' } }}
            />
          </MenuItem>,
        ]
      })}
    </Menu>
  )
}

export default VariableInsertMenu
